'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalBody = require('react-bootstrap/lib/ModalBody');

var _ModalBody2 = _interopRequireDefault(_ModalBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ModalBody2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/ModalBody.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/ModalBody.js
 ** module chunks = 0
 **/